import {
  useGetQuery,
  useLazyGetQuery,
  usePostMutation,
  usePutMutation,
  useDeleteMutation,
} from "slices/api";
import { ROAD } from "tagTypes";

export const useRoadQuery = (query = {}) =>
  useGetQuery({
    endpoint: "/road",
    query,
    tags: [ROAD],
  });

export const useLazyRoadQuery = () => {
  const [getRoad, data] = useLazyGetQuery();
  const road = async (query = {}) =>
    await getRoad(
      {
        endpoint: "/road",
        query,
        tags: [ROAD],
      },
      true
    ).unwrap();
  return [road, data];
};

export const usePostRoadMutation = () => {
  const [road, data] = usePostMutation();
  const addRoad = async (payload, query = {}) =>
    await road({
      endpoint: "/road",
      query,
      payload: payload || {},
      toastMessage: "Road added successfully",
      tags: [ROAD],
    }).unwrap();

  return [addRoad, data];
};

export const usePutRoadMutation = () => {
  const [road, data] = usePutMutation();
  const updateRoad = async (payload, id, query = {}) =>
    await road({
      endpoint: `/road/${id}`,
      query,
      payload: payload || {},
      toastMessage: "Road updated successfully",
      tags: [ROAD],
    }).unwrap();
  return [updateRoad, data];
};

export const useDeleteRoadMutation = () => {
  const [road, data] = useDeleteMutation();
  const deleteRoad = async (id, query = {}) =>
    await road({
      endpoint: `/road/${id}`,
      query,
      toastMessage: "Road deleted successully",
      tags: [ROAD],
    }).unwrap();
  return [deleteRoad, data];
};
